export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    NOTIFY: 'ALERT_NOTIFY',
    CLEAR: 'ALERT_CLEAR',
    RESET_APP: 'RESET_APP',
};
